import type { ReactNode } from 'react';

import deleteIcon from '@/assets/images/delete.webp';

import { Modal } from '../modal';
import { OverlayPattern } from '../overlay';

import styles from './dialog.module.scss';

export type ConfirmDialogProps = {
  open: boolean;
  title: ReactNode;
  subtitle?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  /** Half-width Cancel / confirm buttons on the card, 15px body (Figma 1422:612060). */
  fillActions?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** ✕ / Escape / mask. Defaults to `onCancel`; set it when the cancel button is the destructive
   *  answer (a navigation guard whose "Leave" sits in the cancel slot) and a dismissal must not be. */
  onDismiss?: () => void;
};

export function ConfirmDialog({
  open,
  title,
  subtitle,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  danger = false,
  loading = false,
  icon,
  fillActions = false,
  onConfirm,
  onCancel,
  onDismiss,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onDismiss ?? onCancel}
      size="sm"
      loading={loading}
      primaryText={confirmText}
      onPrimary={onConfirm}
      primaryDanger={danger}
      cancelText={cancelText}
      onCancel={onCancel}
      footerAlign={fillActions ? 'fill' : 'center'}
    >
      <div className={[styles.layout, fillActions ? styles.fillActions : ''].join(' ')}>
        <OverlayPattern className={styles.pattern} />
        <span className={styles.iconWrap}>
          {icon ?? <img src={deleteIcon} alt="" aria-hidden="true" className={styles.icon} />}
        </span>
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
    </Modal>
  );
}
